import ComponentBasePrototype from 'ComponentBasePrototype';
import $ from 'jquery';

export default class SearchHero extends ComponentBasePrototype {
  build() {
    const searchIcon = `
      <svg class="icon icon--2019-search">
        <use xlink:href="/.resources/pride-ui-module/webresources/assets/icons/svg.svg#search"></use>
      </svg>`;

    this.overlay = this.node.find('.cms-customer-support-search-hero__overlay');
    this.visibleResultsContainerClass = 'cms-customer-support-search-hero__results-container--visible';
    const client = new AddSearchClient(this.node.data('searchkey'));

    if (this.node.data('sitename') === 'teliafiyrityksille') {
      client.setCategoryFilters('1xyrityksille/2xasiakastuki');
    } else if (this.node.data('sitename') === 'teliafiyrityksille_english') {
      client.setCategoryFilters('1xbusiness/2xcustomer-support');
    } else {
      client.setCategoryFilters('1xasiakastuki');
    }
    this.searchui = new AddSearchUI(client);
    this.searchui.registerHandlebarsHelper('formatCategory', (results) => this.formatCategories(results));
    this.searchui.registerHandlebarsHelper('formatTitle', (title) => this.formatTitle(title));
    this.searchui.registerHandlebarsHelper('sortByCategory', (results) => this.sortByCategory(results));

    // TODO: Contains static "Search field" aria label text
    const searchfieldTemplate = `
      <div class="cms-customer-support-search-hero__search-container">
        <div class="cms-customer-support-search-hero__search-icon">
          ${searchIcon}
        </div>

        <form class="addsearch-searchfield" autocomplete="off" action="?" role="search">
          <input type="search" placeholder="{{placeholder}}" aria-label="Hakukenttä" role="combobox" aria-expanded="false" aria-autocomplete="list" aria-controls="search-listbox"/>
        </form>
      </div>
    `;

    const resultsTemplate = `
      <div class="addsearch-searchresults">
        {{#each (sortByCategory hits) }}
          <div class="category-title">{{ category }}</div>

          {{#each items }}
            <div class="hit">
              <a class="addsearch-searchresults__result-title" href="{{url}}" data-analytics-click="{{id}}">
                <div>
                  <svg class="icon icon--chevron-right">
                    <use xlink:href="/.resources/pride-ui-module/webresources/assets/icons/svg.svg#chevron-right"></use>
                  </svg>
                </div>

                <span>
                  {{formatTitle title}}
                </span>
              </a>

              {{#gt categories.length 1}}
                <div class="category">
                  {{formatCategory ..}}
                </div>
              {{/gt}}
            </div>
          {{/each}}
        {{/each}}
      </div>
    `;

    const autocompleteTemplate = `
      {{#gt suggestions.length 0}}
        <ul class="suggestions">
          {{#each ../suggestions}}
            <li data-keyword="{{value}}" data-index="{{@index}}" class="addsearch-suggestion {{#equals ../../activeSuggestionIndex @index}}addsearch-suggestion--active{{/equals}}">
              ${searchIcon}

              {{value}}
            </li>
          {{/each}}
        </ul>
      {{/gt}}
    `;

    // TODO: Contains static no-search-results text
    const noResultsTemplate = `
      <div class="addsearch-searchresults addsearch-searchresults--no-results" tabindex="0">
        <p>Ei hakutuloksia hakusanalla <strong>{{keyword}}</strong></p>
      </div>
    `;

    this.searchui.searchField({
      containerId: 'searchfield-container',
      placeholder: this.node.data('placeholder'),
      searchAsYouType: true,
      autofocus: false,
      ignoreSearchResultsPageUrl: true,
      template: searchfieldTemplate,
    });

    this.searchui.searchResults({
      containerId: 'results-container',
      client,
      template: resultsTemplate,
      template_noresults: noResultsTemplate,
      categorySelectionFunction: this.formatCategories,
    });

    this.searchui.autocomplete({
      containerId: 'autocomplete-container',
      template: autocompleteTemplate,
      hideAutomatically: false,
      sources: [
        {
          type: AddSearchUI.AUTOCOMPLETE_TYPE.SUGGESTIONS,
          client,
          jsonKey: 'suggestions',
        },
      ],
    });

    this.searchui.start();
    this.searchField = this.node.find('.addsearch-searchfield > input');
    this.resultsContainer = this.node.find('.cms-customer-support-search-hero__results-container');
    this.getInputState();

    this.searchField.focusin(() => {
      if (!this.overlay.hasClass('cms-customer-support-search-hero__overlay--active')) {
        this.overlay.addClass('cms-customer-support-search-hero__overlay--active');
      }
    });

    this.searchField.on('keyup', (evt) => {
      if (evt.key === "Escape") {
        this.resultsContainer.removeClass(this.visibleResultsContainerClass);
      }
    });

    this.searchField.on('keydown', (evt) => {
      const isShiftPressed = evt.shiftKey;
      if (evt.keyCode === 9 && isShiftPressed) {
        this.hideResults();
      } else if (evt.keyCode === 9 && !isShiftPressed) {
        if (!this.resultsContainer.hasClass(this.visibleResultsContainerClass) && this.overlay.hasClass('cms-customer-support-search-hero__overlay--active')) {
          this.overlay.removeClass('cms-customer-support-search-hero__overlay--active');
        }
        this.resultsContainerLinks = this.node.find('.addsearch-searchresults__result-title');
        this.resultsContainerLinks.on('keyup', (e) => {
          if (e.key === "Escape") {
            this.resultsContainer.removeClass(this.visibleResultsContainerClass);
            this.searchField.focus();
          }
        });
        if (this.resultsContainerLinks.length) {
          let lastElement = this.resultsContainerLinks.last();
          lastElement.focusout(() => {
            this.hideResults();
          });
        } else {
          this.noResultsContainer = this.node.find('.addsearch-searchresults--no-results');
          this.noResultsContainer.focusout(() => {
            this.hideResults();
          });
        }
      }
    });

    this.searchField.on('input', (e) => {
      if (e.target.value !== '') {
        if (this.resultsContainer.hasClass(this.visibleResultsContainerClass)) {
          return;
        }
        this.showResults();
      } else if (this.resultsContainer.hasClass(this.visibleResultsContainerClass)) {
        this.searchField.attr('aria-expanded', 'false');
        if (this.searchField.is(':focus')) {
          this.resultsContainer.removeClass(this.visibleResultsContainerClass);
          return;
        }
        this.hideResults();
      }
    });

    this.overlay.on('click', () => {
      this.hideResults();
    });

  }

  getInputState() {
    if (this.searchField.val() !== '') {
      this.showResults();

      if ($('.content-article--customerSupport2020').length) {
        this.scrollToHero();
        return;
      }

      const waitUntilReactHasLoaded = setInterval(() => {
        if ($('.telia-react-element').length) {
          this.scrollToHero();
          clearInterval(waitUntilReactHasLoaded);
        }
      }, 100);
    }
  }

  scrollToHero() {
    $('html, body').animate({
      // +20px will scroll to search field
      scrollTop: $('.cms-customer-support-search-hero__container').position().top,
    }, 1000);
  }

  hideResults() {
    this.searchField.attr('aria-expanded', 'false');
    this.searchui.clear();
    this.resultsContainer.removeClass(this.visibleResultsContainerClass);
    this.overlay.removeClass('cms-customer-support-search-hero__overlay--active');
  }

  showResults() {
    this.resultsContainer.addClass(this.visibleResultsContainerClass);
    this.overlay.addClass('cms-customer-support-search-hero__overlay--active');
    this.searchField.attr('aria-expanded', 'true');
  }

  formatCategories(result) {
    if (this.doesHaveCustomCategory(result)) {
      return result.custom_fields.displayCategory;
    }

    const formattedCategories = result.categories.map((category) => this.formatCategory(category));
    return formattedCategories.slice(2, 4).join(' > ');
  }

  formatCategory(category) {
    const formattedCategory = category.replace(/^[0-9]+[x]{1}/, '').split('-');
    return this.capitalize(formattedCategory);
  }

  formatTitle(title) {
    return title.split('|')[0].trim();
  }

  capitalize(words) {
    const firstWord = words[0];
    const capitalized = firstWord.charAt(0).toUpperCase() + firstWord.slice(1);
    return [capitalized, ...words.slice(1)].join(' ');
  }

  doesHaveCustomCategory(result) {
    return result.custom_fields && result.custom_fields.displayCategory;
  }

  getMainCategory(result) {
    const displayCategory = result.custom_fields.displayCategory;
    return (Array.isArray(displayCategory)) ? displayCategory[0].split('>')[0].trim() : displayCategory.split('>')[0].trim();
  }

  sortByCategory(results) {
    if (results) {
      return this.groupBy(results, (result) => (this.doesHaveCustomCategory(result) ? this.getMainCategory(result) : result.categories[2]));
    }

    return [];
  }

  groupBy(list, keyGetter) {
    const grouped = {};

    list.forEach((item) => {
      const key = keyGetter(item) || 'Asiakastuki';

      if (grouped[key]) {
        grouped[key].push(item);
      } else {
        grouped[key] = [{ ...item }];
      }
    });

    const result = [];

    Object.keys(grouped).map((key) => result.push({ category: this.formatCategory(key), items: grouped[key] }));

    return result;
  }

}
